<template>
	<c-modal @close="close" :title="'Verwijderen?'">

		<p class="margin-t-32">Weet je zeker dat je deze rol definitief wilt verwijderen?</p>

		<c-button 
			class="c-btn--hollow c-btn--expanded margin-t-32 margin-b-16"
			@click="$store.dispatch('roles/delete', item); close()">
			Ja, rol verwijderen 	
		</c-button>

		<c-button class="c-btn--expanded no-margin-b" @click="close()">
			Nee, rol behouden
		</c-button>

	</c-modal>
</template>

<script>
import CModal from '@components/Modal';
import Form from '@mixins/Form';

export default {
	mixins: [Form],
	components: {
		CModal
	},
	props: {
		item: {
			required: true,
			type: Object
		},
	},
	data() {
		return {
			text: ''
		};
	},
	watch: {
	},
	methods: {
		close() {
			this.$emit('close');
		},
		
	},
	mounted() {
	}
}
</script>